<template lang="pug">
  #signUpIndex
    .container-width.p-3
      //- h5.titleStyle.text-center.font-weight-bold.mb-4 申請LINE個人化服務
      #step1(v-if="nowStep == 1")
        .text-area-scroll.mb-2
          .line-text-header.mb-2
            .title.font-weight-bold 個資蒐集、處理及利用告知事項
          .line-text-header.mb-2
            .title.font-weight-bold 為了保護您個人資料，僅依個人資料保護法第 8條規定告知以下事項：
          .line-text-body.py-2.text-justify
            ul.pl-4
              li 蒐集公司：香港商亞洲華敦通商有限公司台灣分公司及其關係企業(以下簡稱華敦集團)。
              li 蒐集目的：華敦集團中華民國境內外各相關企業之活動參與、身份確認、客戶管理、提供服務、聯絡通知、行銷、市場推廣、統計、調查、研究等。
              li 個人資料類別：中英文姓名、性別、生日、年齡、職業、通訊、E-mail、地址及其他得以直接或間接識別本人之資料。
              li 個人資料利用期間：華敦營運期間。
              li 個人資料利用地區：中華民國境內外地區
              li 利用對象及方式：您的個人資料將由華敦集團及受華敦集團委託之第三方合作廠商(包括但不限於與中介代理、承辦商、EC與第三方認證業者如google、 Facebook、Apple、Line等，或提供行政、電訊、數據處理、電腦支援或客戶服務等的第三方服務商)在蒐集目的之範圍內予以利用。
              li 您享有個資法之權利：查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理及利用、請求刪除。上述有關個人資料之查詢或更正，或個資之閱覽、製給複製本、停止或刪除等部份、華敦集團只接受以書面方式通知後，再行政處理之。惟華敦執行職務或業務必須者，得不予停止或刪除。
              li 若您未能提供個人資料，將無法享有華敦相關服務。
          .line-text-bottom
        b-form-checkbox.text-center.font-weight-bold.mb-3(
          id="agree"
          v-model="agree_status"
          name="agree"
          :value="true"
          :unchecked-value="false"
        ) 我已詳閱並同意使用須知及相關條款
        .px-4.fakePadding_h-50.position-relative
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom.position-absolute(
            @click="nextStepHandler()"
          )
            | 下一步
      #step2(v-if="nowStep == 2")
        .mb-4.mb-2
          p 請輸入您的個人資料
            | 。
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="userForm"
            tag="form"
            @submit.stop.prevent="submitHandler"
          )
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValName",
                v-slot="{ errors }"
              )
                b-form-input.inputStyle(
                  id="name",
                  type="text",
                  required,
                  trim,
                  :state="validState('name')",
                  v-model="userForm.name",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入姓名"
                  :disabled='disabledName'
                )
                b-form-invalid-feedback.text-center(
                  id="input-name-live-feedback"
                )
                  span {{ errors[0] }}
            b-form-group
              ValidationProvider(
                rules="required|mobile",
                ref="inputValMobile",
                v-slot="{ errors }"
              )
                b-form-input.inputStyle(
                  id="mobile",
                  type="tel",
                  required,
                  trim,
                  :state="validState('mobile')",
                  v-model="userForm.mobile",
                  aria-describedby="input-live-help input-mobile-live-feedback",
                  placeholder="請輸入手機"
                )
                b-form-invalid-feedback.text-center(
                  id="input-mobile-live-feedback"
                )
                  span {{ errors[0] }}

            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValGender",
                v-slot="{ errors }"
              )
                multiselect.multiselect__circle(
                  track-by="id",
                  label="name",
                  placeholder="請選擇性別",
                  :options="genderDropdown",
                  :searchable="false",
                  :allow-empty="false",
                  v-model="userForm.selectedGender",
                  selectLabel='',
                  deselect-label='',
                  noOptions="無可選擇性別"
                  :state="validState('gender')",
                  :class="{ 'has-value': userForm.selectedGender, 'is-invalid': errors[0] }"
                )
                  template(slot="noOptions")
                    strong 無可選擇性別
                b-form-invalid-feedback.text-center(
                  id="input-mobile-live-feedback"
                )
                  span {{ errors[0] }}

            b-form-group
              .d-flex.no-gutters
                .col-4
                  ValidationProvider(
                    rules="required",
                    ref="inputValBirthYear",
                    v-slot="{ errors }"
                  )
                    b-form-select.rounded-0.border-black(
                      id="birthYear",
                      required,
                      v-model="userForm.birthYear",
                      :state="validState('birthYear')",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="",
                      :class="{ 'has-value': userForm.birthYear }"
                      @change='changeBirthDateOption()'
                    )
                      template(
                        v-slot:first
                      )
                        b-form-select-option(
                          :value="null",
                          disabled
                          selected
                        ) YYYY
                      b-form-select-option(
                        v-for="(store,index) in birthYearOptions",
                        :key="store.id",
                        :value="store.id"
                      ) {{ store.title }}
                    b-form-invalid-feedback.text-center(
                      id="input-name-live-feedback"
                    )
                      span {{ errors[0] }}

                .col-4
                  ValidationProvider(
                    rules="required",
                    ref="inputValBirthMonth",
                    v-slot="{ errors }"
                  )
                    b-form-select.rounded-0.border-black(
                      id="birthYear",
                      required,
                      v-model="userForm.birthMonth",
                      :state="validState('birthMonth')",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="",
                      :class="{ 'has-value': userForm.birthMonth }"
                      @change='changeBirthDateOption()'
                    )
                      template(
                        v-slot:first
                      )
                        b-form-select-option(
                          :value="null",
                          disabled
                          selected
                        ) MM
                      b-form-select-option(
                        v-for="(store,index) in birthMonthOptions",
                        :key="store.id",
                        :value="store.id"
                      ) {{ store.title }}
                    b-form-invalid-feedback.text-center(
                      id="input-name-live-feedback"
                    )
                      span {{ errors[0] }}
                .col-4
                  ValidationProvider(
                    rules="required",
                    ref="inputValBirthDate",
                    v-slot="{ errors }"
                  )
                    b-form-select.rounded-0.border-black(
                      id="birthYear",
                      required,
                      v-model="userForm.birthDate",
                      :state="validState('birthDate')",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="",
                      :class="{ 'has-value': userForm.birthDate }"
                    )
                      template(
                        v-slot:first
                      )
                        b-form-select-option(
                          :value="null",
                          disabled
                          selected
                        ) DD
                      b-form-select-option(
                        v-for="(store,index) in birthDateOptions",
                        :key="store.id",
                        :value="store.id"
                      ) {{ store.title }}
                    b-form-invalid-feedback.text-center(
                      id="input-name-live-feedback"
                    )
                      span {{ errors[0] }}

          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValCity",
              v-slot="{ errors }"
            )
              multiselect.multiselect__circle(
                track-by="id",
                label="city_name",
                placeholder="請選擇居住縣市",
                :options="cityOption",
                :searchable="false",
                :allow-empty="false",
                v-model="city",
                selectLabel='',
                deselect-label='',
                noOptions="無可選擇縣市"
                :class="{ 'is-invalid': errors[0] }"
                @select='changeAreaOption'
              )
                template(slot="noOptions")
                  strong 無可選擇縣市
              b-form-invalid-feedback.text-center(
                id="input-mobile-live-feedback"
              )
                span {{ errors[0] }}
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValZip",
              v-slot="{ errors }"
            )
              multiselect.multiselect__circle(
                track-by="zip_no",
                label="zip_name",
                placeholder="請選擇居住地區",
                :options="zipNaOption",
                :searchable="false",
                :allow-empty="false",
                v-model="zip_na",
                selectLabel='',
                deselect-label='',
                noOptions="無可選擇地區"
                :class="{ 'is-invalid': errors[0] }"
              )
                template(slot="noOptions")
                  strong 無可選擇地區
              b-form-invalid-feedback.text-center(
                id="input-mobile-live-feedback"
              )
                span {{ errors[0] }}

        label 親愛的顧客請注意，為了通知與提醒您的相關權益與福利，我們會藉由以下方式聯繫您，如有不想接受的聯繫方式，請您勾選，謝謝
        b-form-group
          b-form-checkbox(
            :id="`checkbox-pr-1`",
            name="selectTemps1",
            v-model="userForm.pr_phone",
          ) 不接受電話
        b-form-group.mb-3.pb-5
          b-form-checkbox(
            :id="`checkbox-pr-2`",
            name="selectTemps2",
            v-model="userForm.pr_sms",
          ) 不接受簡訊

        //b-form-group
        //  b-form-checkbox(
        //    :id="`checkbox-pr-3`",
        //    name="selectTemps3",
        //    v-model="userForm.pr_letter",
        //  ) 不接受郵寄
        //b-form-group.mb-3.pb-5
        //  b-form-checkbox(
        //    :id="`checkbox-pr-4`",
        //    name="selectTemps4",
        //    v-model="userForm.pr_email",
        //  ) 不接受email
        //p.text-center.mb-3
          code *字號
          span 為選填選項，其餘選項皆為必填
        .mb-3
        .px-4.fakePadding_h-50.position-relative
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom.position-absolute(
            type="button",
            @click="nextStepHandler()"
          )
            | 下一步
      #step3(v-if="nowStep == 3")
        .mb-4
          p.text-center 請輸入發送至您手機的驗證碼
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="mobileVerfityForm"
            tag="form"
            @submit.stop.prevent="checkSMS()"
          )
            b-form-group.mb-0
              ValidationProvider(
                rules="required",
                ref="inputValMobileVerfity"
              )
                b-form-input.inputStyle(
                  id="mobileVerfity",
                  type="text",
                  required,
                  trim,
                  :state="validverfityState()",
                  v-model="mobileVerfityCode",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入驗證碼"
                )
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span 簡訊驗證碼不可為空
              .text-center
                  .mt-2(
                    v-if="verfityNowTime == 0"
                  )
                    button.btn.btn-black.rounded-50.mt-2(
                      type="button",
                      @click="countDownHandler"
                    )
                      i.fas.fa-redo.fa-md.arrorIcon.pr-1
                      span 重發驗證碼
                  .mt-2(
                    v-else
                  )
                    code {{ verfityNowTime }}秒
                    span 後可重發驗證碼
        .px-4
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom.position-absolute(
            type="button",
            @click="nextStepHandler()"
          )
            | 下一步

</template>

<script>
import { mapState } from 'vuex';
import StepComponent from '@/components/step/StepComponent.vue'; // 客製化進度條
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import { U_M_SIGN_UP_SUCCESS } from '@/router/unbind-member/sign-up';
const _ = require('lodash');
const moment = require('moment');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化身分證驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

export default {
  name: 'SignUpIndex',
  components: {
    StepComponent,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    sa_id: {
      type: [String, Number],
      required: false
    },
    store_id: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      companyName: 'Hearth',
      nowStep: 1,
      agree_status: false,
      firstType: true, // 第一次進來輸入資料
      userForm: {
        lastName: null,
        firstName: null,
        mobile: null,
        name: null,
        selectedGender: null,
        birthYear: null,
        birthMonth: null,
        birthDate: null,
        pr_phone: 0,
        pr_sms: 0,
      },
      mobileVerfityCode: null,
      verfityTotalTime: 180,
      verfityNowTime: 0,
      verfityCanClick: true,
      disabledName: false,
      genderDropdown: [
        {
          id: 1,
          name: '男'
        },
        {
          id: 0,
          name: '女'
        },
        {
          id: 2,
          name: '不透露'
        },
      ],
      birthYearOptions: [],
      birthMonthOptions: [],
      birthDateOptions: [],
      city: null,
      zip_na: null,
      cityOption: [],
      zipNaOption: [],
    };
  },
  computed: {
    ...mapState({
      cityDropdown: (state) => state.member_sign_up.cityDropdown,
    })
  },
  mounted() {
    const vm = this;
    // vm.userForm.mobile = '0923911278';
    for (let i = 0; i < 100; i++) {
      vm.birthYearOptions.push({
        id: moment().subtract(i, 'year').format('YYYY'),
        title: moment().subtract(i, 'year').format('YYYY')
      });
    }
    for (let i = 1; i <= 12; i++) {
      vm.birthMonthOptions.push({
        id: i < 10 ? `0${i}` : i,
        title: i
      });
    }

    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('member_sign_up/getCityDropdownHandler').then(() => {
      vm.cityOption = vm.cityDropdown;
    });
  },
  methods: {
    nextStepHandler() {
      const vm = this;
      switch (vm.nowStep.toString()) {
      case '1':
        if (!vm.agree_status) {
          this.$swal.fire({
            icon: 'info',
            title: '請勾選同意事項'
          });
        } else {
          vm.nowStep = 2;
        }
        break;
      case '2':
        vm.countDownHandler();
        break;
      case '3':
        vm.sendBindingInfo();
        break;
      default:
        break;
      }
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.userForm[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.userForm[key]);
        }
        if (key === 'email') {
          const EmailReg = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
          return EmailReg.test(vm.userForm[key]);
        }
        return this.userForm[key] ? true : false;
      }
      return null;
    },
    validverfityState() {
      const vm = this;
      if (vm.mobileVerfityCode !== null) {
        return this.mobileVerfityCode ? true : false;
      }
      return null;
    },
    // 倒數驗證碼
    countDownHandler() {
      const vm = this;
      if (!vm.verfityCanClick) return;
      if (vm.userForm.name === null) vm.userForm.name = '';
      if (vm.userForm.mobile === null) vm.userForm.mobile = '';
      if (vm.userForm.selectedGender === null) vm.userForm.selectedGender = '';
      if (vm.userForm.birthYear === null) vm.userForm.birthYear = '';
      if (vm.userForm.birthMonth === null) vm.userForm.birthMonth = '';
      if (vm.userForm.birthDate === null) vm.userForm.birthDate = '';
      if (vm.city === null) vm.city = '';
      if (vm.zip_na === null) vm.zip_na = '';
      // 發送驗證碼
      vm.$swal.fire({
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });
      this.$refs.userForm.validate().then((res) => {
        if (res) {
          vm.$store.dispatch('member_sign_up/getMemberCrmInfoHandler', vm.userForm.mobile).then((res2) => {
            if (res2.data) {
              vm.$router.push({
                name: U_M_SIGN_UP_SUCCESS,
                params: {
                  alreadyBind: true
                }
              });
              vm.$swal.close();
            } else {
              vm.$store.dispatch('unbind_member_sign_up/sendSmsValidateHandler', vm.userForm.mobile)
                .then(() => {
                  vm.nowStep = 3;
                  vm.$snotify.success(null, '驗證碼已寄出');
                  vm.verfityCanClick = false;
                  vm.verfityNowTime = vm.verfityTotalTime;
                  const clock = window.setInterval(() => {
                    if (vm.verfityNowTime === 0) {
                      window.clearInterval(clock);
                      vm.verfityCanClick = true; // 這裡重新開啟
                    } else {
                      vm.verfityNowTime -= 1;
                    }
                  }, 1000);
                  vm.$swal.close();
                });
            }
          });
        } else {
          if (!vm.userForm.name) {
            vm.$swal.fire({
              icon: 'info',
              title: '請填寫姓名'
            });
          } else if (!vm.userForm.mobile) {
            vm.$swal.fire({
              icon: 'info',
              title: '請填寫手機'
            });
          } else if (!vm.userForm.selectedGender) {
            vm.$swal.fire({
              icon: 'info',
              title: '請選擇性別'
            });
          } else if (!vm.userForm.birthYear) {
            vm.$swal.fire({
              icon: 'info',
              title: '請選擇生日年'
            });
          } else if (!vm.userForm.birthMonth) {
            vm.$swal.fire({
              icon: 'info',
              title: '請選擇生日月'
            });
          } else if (!vm.userForm.birthDate) {
            vm.$swal.fire({
              icon: 'info',
              title: '請選擇生日日'
            });
          } else if (!vm.city) {
            vm.$swal.fire({
              icon: 'info',
              title: '請選擇縣市'
            });
          } else if (!vm.zip_na) {
            vm.$swal.fire({
              icon: 'info',
              title: '請選擇地區'
            });
          }
        }
      });
    },
    sendBindingInfo() {
      const vm = this;
      if (!vm.userForm.name) {
        vm.$swal.fire({
          icon: 'info',
          title: '請填寫姓名'
        });
      } else if (!vm.userForm.mobile) {
        vm.$swal.fire({
          icon: 'info',
          title: '請填寫手機'
        });
      } else if (!vm.userForm.selectedGender) {
        vm.$swal.fire({
          icon: 'info',
          title: '請選擇性別'
        });
      } else if (!vm.userForm.birthYear) {
        vm.$swal.fire({
          icon: 'info',
          title: '請選擇生日年'
        });
      } else if (!vm.userForm.birthMonth) {
        vm.$swal.fire({
          icon: 'info',
          title: '請選擇生日月'
        });
      } else if (!vm.userForm.birthDate) {
        vm.$swal.fire({
          icon: 'info',
          title: '請選擇生日日'
        });
      } else {
        vm.$store.commit('toggleLoading', true);
        const input = {
          chinese_first_name: vm.userForm.name,
          mobile: vm.userForm.mobile,
          gender: vm.userForm.selectedGender.id,
          birthday: `${vm.userForm.birthYear}/${ vm.userForm.birthMonth }/${ vm.userForm.birthDate}`,
          code: vm.mobileVerfityCode,
          pr_phone: vm.userForm.pr_phone ? 1 : 0,
          pr_sms: vm.userForm.pr_sms ? 1 : 0,
          zip_no: vm.zip_na.zip_no,
          // pr_letter: vm.userForm.pr_letter ? 1 : 0,
          // pr_email: vm.userForm.pr_email ? 1 : 0,
        };
        vm.$store.dispatch('unbind_member_sign_up/sendBindingHandler', input).then((res) => {
          vm.$store.commit('toggleLoading', false);
          vm.$router.push({
            name: U_M_SIGN_UP_SUCCESS
          });
          vm.$swal.close();
        });
      }
    },
    changeBirthDateOption() {
      const vm = this;
      vm.userForm.birthDate = null;
      vm.birthDateOptions = [];
      if (vm.userForm.birthYear && vm.userForm.birthMonth) {
        const lastDateOfMonth = moment(`${vm.userForm.birthYear}-${vm.userForm.birthMonth}`, 'YYYY-MM').endOf('month').format('DD');
        for (var i = 1; i <= lastDateOfMonth; i++) {
          vm.birthDateOptions.push({
            id: i < 10 ? `0${i}` : i,
            title: i
          });
        }
      }
    },
    changeAreaOption(val) {
      const vm = this;
      vm.zip_na = null;
      vm.zipNaOption = val.zip;
    }
  }
};
</script>

<style>

</style>
